function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Leaf = /*#__PURE__*/function () {
  function Leaf(trie) {
    _classCallCheck(this, Leaf);

    this.children = [];
    this.parent = trie;
  }

  _createClass(Leaf, [{
    key: "delete",
    value: function _delete(value) {
      var index = this.children.indexOf(value);
      if (index === -1) return false;
      this.children = this.children.slice(0, index).concat(this.children.slice(index + 1));

      if (this.children.length === 0) {
        this.parent.delete(this);
      }

      return true;
    }
  }, {
    key: "add",
    value: function add(value) {
      this.children.push(value);
      return this;
    }
  }]);

  return Leaf;
}();

var RadixTrie = /*#__PURE__*/function () {
  function RadixTrie(trie) {
    _classCallCheck(this, RadixTrie);

    this.parent = null;
    this.children = {};
    this.parent = trie || null;
  }

  _createClass(RadixTrie, [{
    key: "get",
    value: function get(edge) {
      return this.children[edge];
    }
  }, {
    key: "insert",
    value: function insert(edges) {
      var currentNode = this;

      for (var i = 0; i < edges.length; i += 1) {
        var edge = edges[i];
        var nextNode = currentNode.get(edge);

        if (i === edges.length - 1) {
          if (nextNode instanceof RadixTrie) {
            currentNode.delete(nextNode);
            nextNode = null;
          }

          if (!nextNode) {
            nextNode = new Leaf(currentNode);
            currentNode.children[edge] = nextNode;
          }

          return nextNode;
        } else {
          if (nextNode instanceof Leaf) nextNode = null;

          if (!nextNode) {
            nextNode = new RadixTrie(currentNode);
            currentNode.children[edge] = nextNode;
          }
        }

        currentNode = nextNode;
      }

      return currentNode;
    }
  }, {
    key: "delete",
    value: function _delete(node) {
      for (var edge in this.children) {
        var currentNode = this.children[edge];

        if (currentNode === node) {
          var success = delete this.children[edge];

          if (Object.keys(this.children).length === 0 && this.parent) {
            this.parent.delete(this);
          }

          return success;
        }
      }

      return false;
    }
  }]);

  return RadixTrie;
}();

function isFormField(element) {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  var name = element.nodeName.toLowerCase();
  var type = (element.getAttribute('type') || '').toLowerCase();
  return name === 'select' || name === 'textarea' || name === 'input' && type !== 'submit' && type !== 'reset' && type !== 'checkbox' && type !== 'radio' || element.isContentEditable;
}

function fireDeterminedAction(el, path) {
  var delegateEvent = new CustomEvent('hotkey-fire', {
    cancelable: true,
    detail: {
      path: path
    }
  });
  var cancelled = !el.dispatchEvent(delegateEvent);
  if (cancelled) return;

  if (isFormField(el)) {
    el.focus();
  } else {
    el.click();
  }
}

function expandHotkeyToEdges(hotkey) {
  var output = [];
  var acc = [''];
  var commaIsSeparator = false;

  for (var i = 0; i < hotkey.length; i++) {
    if (commaIsSeparator && hotkey[i] === ',') {
      output.push(acc);
      acc = [''];
      commaIsSeparator = false;
      continue;
    }

    if (hotkey[i] === ' ') {
      acc.push('');
      commaIsSeparator = false;
      continue;
    } else if (hotkey[i] === '+') {
      commaIsSeparator = false;
    } else {
      commaIsSeparator = true;
    }

    acc[acc.length - 1] += hotkey[i];
  }

  output.push(acc);
  return output.map(function (h) {
    return h.filter(function (k) {
      return k !== '';
    });
  }).filter(function (h) {
    return h.length > 0;
  });
}

function hotkey(event) {
  var ctrlKey = event.ctrlKey,
      altKey = event.altKey,
      metaKey = event.metaKey,
      key = event.key;
  var hotkeyString = [];
  var modifiers = [ctrlKey, altKey, metaKey, showShift(event)];

  var _iterator = _createForOfIteratorHelper(modifiers.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var i = _ref2[0];
      var mod = _ref2[1];
      if (mod) hotkeyString.push(modifierKeyNames[i]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!modifierKeyNames.includes(key)) {
    hotkeyString.push(key);
  }

  return hotkeyString.join('+');
}

var modifierKeyNames = ["Control", 'Alt', 'Meta', 'Shift'];

function showShift(event) {
  var shiftKey = event.shiftKey,
      code = event.code,
      key = event.key;
  return shiftKey && !(code.startsWith('Key') && key.toUpperCase() === key);
}

var hotkeyRadixTrie = new RadixTrie();
var elementsLeaves = new WeakMap();
var currentTriePosition = hotkeyRadixTrie;
var resetTriePositionTimer = null;
var path = [];

function resetTriePosition() {
  path = [];
  resetTriePositionTimer = null;
  currentTriePosition = hotkeyRadixTrie;
}

function keyDownHandler(event) {
  if (event.defaultPrevented) return;
  if (!(event.target instanceof Node)) return;

  if (isFormField(event.target)) {
    var target = event.target;
    if (!target.id) return;
    if (!target.ownerDocument.querySelector("[data-hotkey-scope=\"".concat(target.id, "\"]"))) return;
  }

  if (resetTriePositionTimer != null) {
    window.clearTimeout(resetTriePositionTimer);
  }

  resetTriePositionTimer = window.setTimeout(resetTriePosition, 1500);
  var newTriePosition = currentTriePosition.get(hotkey(event));

  if (!newTriePosition) {
    resetTriePosition();
    return;
  }

  path.push(hotkey(event));
  currentTriePosition = newTriePosition;

  if (newTriePosition instanceof Leaf) {
    var _target = event.target;
    var shouldFire = false;
    var elementToFire;
    var formField = isFormField(_target);

    for (var i = newTriePosition.children.length - 1; i >= 0; i -= 1) {
      elementToFire = newTriePosition.children[i];
      var scope = elementToFire.getAttribute('data-hotkey-scope');

      if (!formField && !scope || formField && _target.id === scope) {
        shouldFire = true;
        break;
      }
    }

    if (elementToFire && shouldFire) {
      fireDeterminedAction(elementToFire, path);
      event.preventDefault();
    }

    resetTriePosition();
  }
}

function install(element, hotkey) {
  if (Object.keys(hotkeyRadixTrie.children).length === 0) {
    document.addEventListener('keydown', keyDownHandler);
  }

  var hotkeys = expandHotkeyToEdges(hotkey || element.getAttribute('data-hotkey') || '');
  var leaves = hotkeys.map(function (h) {
    return hotkeyRadixTrie.insert(h).add(element);
  });
  elementsLeaves.set(element, leaves);
}

function uninstall(element) {
  var leaves = elementsLeaves.get(element);

  if (leaves && leaves.length) {
    var _iterator2 = _createForOfIteratorHelper(leaves),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var leaf = _step2.value;
        leaf && leaf.delete(element);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  if (Object.keys(hotkeyRadixTrie.children).length === 0) {
    document.removeEventListener('keydown', keyDownHandler);
  }
}

export { Leaf, RadixTrie, hotkey as eventToHotkeyString, install, uninstall };